// extracted by mini-css-extract-plugin
module.exports = {"gallery":"NewPhotoGallery_gallery__2wdtU","photo":"NewPhotoGallery_photo__cLh8b"};